import { gql } from '@apollo/client';
import React, { Component } from 'react';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import '../../../assets/scss/projectTable.scss';
import { Space } from 'antd';
import LabelCard from '../Deliverables/LabelCard';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _ from 'lodash';
import moment from 'moment';
import { subscribe } from 'graphql';
// import "../../../assets/scss/projects.scss"
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import constants from '../../../utils/constants';
const getFlags = gql`
	query ModuleFlags($filters: FlagListFiltersInput) {
		moduleFlags(filters: $filters) {
			activeFlagsCount
			code
			department
			severity
			priority
			description
		}
	}
`;
const getProjects = gql`
	query VendorsProjects($filters: projectsListFiltersInput, $workspaceIds: [String!]) {
		vendorsProjects(filters: $filters, workspaceIds: $workspaceIds) {
			data {
				id
				title
				events {
					date
				}
				hardDrives {
					size
				}
				collaborators {
					designations
					tenantUserId
				}
				firstEvent {
					date
					name
				}
				lastEvent {
					date
					name
				}
				weddingEvent {
					date
					name
				}
				tenantId
				slNo
				deliverables {
					_id
					title
					status
					priority
					cost
					completedAt
					dueDate
				}
			}
			currentPage
			hasNextPage
			hasPrevPage
			nextPage
			totalDocs
			totalPages
			limit
			prevPage
		}
	}
`;
const getSearchedDataProjects = gql`
	query VendorsProjects($filters: projectsListFiltersInput, $workspaceIds: [String!]) {
		vendorsProjects(filters: $filters, workspaceIds: $workspaceIds) {
			data {
				id
				title
				events {
					date
				}
				hardDrives {
					size
				}
				collaborators {
					designations
					tenantUserId
				}
				firstEvent {
					date
					name
				}
				lastEvent {
					date
					name
				}
				weddingEvent {
					date
					name
				}
			}
			currentPage
			hasNextPage
			hasPrevPage
			nextPage
			totalDocs
			totalPages
			limit
			prevPage
		}
	}
`;
const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
		}
	}
`;
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				workspaceId
				workspaceKey
				_id
			}
		}
	}
`;
class Projects extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			projectsList: {},
			tenantUserList: {},
			searchLim: 600,
			searchPage: 1,
			activeFlag: '',
			allDataProjectsList: {},
			limit: 20,
			sortBy: '',
			sortType: 0,
			page: 1,
			currentViewPage: 1,
			isPageLoading: false,
			workspacesFilters: [],
			resArray: [],
			workspaceActiveFilter: [],
			workspaceFilterCleared: false,
			projectFilters: [],
			searchWordFound: false,
			searchValue: '',

			clientSearchFilter: '',
			// totalPages: 1,
			columns: [
				// { title: 'FLAG' },
				{ title: 'Project Name' },
				{ title: 'Shoots' },
				{ title: 'Deliverables' },
				{ title: 'Hard Drives' },
				{ title: 'Head Photographers' },
				{ title: 'Head Cinematographers' },
				{ title: 'First Event', sortBy: 'firstEvent' },
				{ title: 'Wedding', sortBy: 'weddingDate' },
				{ title: 'Last Event', sortBy: 'lastEvent' },
			],
		};
	}

	getActiveWorkspaceFilter = () => {
		// If user has selected specific workspaces, use those
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			return this.state.workspaceActiveFilter;
		}
		// If user explicitly cleared the workspace filter, return null to fetch all data
		if (this.state.workspaceFilterCleared) return null;
		// Otherwise use vendor's activeWorkspaces from constants (extract workspaceId)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			return vendorConfig.activeWorkspaces.map(w => w.workspaceId);
		}
		return null;
	};

	componentDidMount = async () => {
		// Pre-select active workspaces from constants (extract workspaceId for filter keys)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			this.setState({ workspaceActiveFilter: vendorConfig.activeWorkspaces.map(w => w.workspaceId) });
		}

		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'searchedQuery') {
					json = {
						...json,
						filters: {
							...json.filters,

							title: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'sortBy') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'activeFlag') {
					json = {
						...json,
						filters: {
							...json.filters,

							code: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'sortType') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'workspaceIds') {
					let workspaceActiveFilter = subString[1].split(',');
					this.setState({
						workspaceActiveFilter,
					});
					json = {
						...json,
						filters: {
							...json.filters,
						},
						workspaceIds: workspaceActiveFilter,
					};
				}
				// if (subString[0] === 'workspaceIds') {
				//     this.setState({
				//         workspaceActiveFilter: subString[1].split(','),
				//     })
				// } else
				if (subString[0] === 'page' || subString[0] === 'limit') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				} else if (subString[0] === 'searchedQuery') {
					this.setState({
						searchValue: subString[1],
					});
				} else if (subString[0] === 'activeFlag') {
					this.setState({
						[subString[0]]: subString[1],
					});
				} else if (subString[0] === 'sortBy') {
					this.setState({
						[subString[0]]: subString[1],
					});
				} else if (subString[0] === 'sortType') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				}
				count++;
			}
		} else {
			json = {
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
				},
			};
		}
		// Apply active workspaces filter on initial load if not set from URL
		const wsFilter = this.getActiveWorkspaceFilter();
		if (wsFilter && !json.workspaceIds) {
			json = {
				...json,
				workspaceIds: wsFilter,
			};
		}
		await this.getProjectsList(getProjects, json);
		this.getFlags(getFlags, {
			filters: {
				module: 'projects',
			},
		});
		this.getTenantUsers(getTenantUserList);
		this.getVendorsWorkspaces(
			getVendorInfo,
			{
				vendorId: this.props.params.vendorID,
			},
			'modify-object',
		);
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreProjects();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreProjects();
			},
		);
	};
	handleFlag = async (code) => [
		this.setState(
			{
				activeFlag: this.state.activeFlag === code ? '' : code,
			},
			async () => {
				await this.fetchMoreProjects();
			},
		),
	];
	onClickPreviousPage = async () => {
		if (this.state.page > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreProjects();
				},
			);
		}
	};
	//handling workspace filter
	handleActiveFilter = async (e, type, key) => {
		let array;

		if (type === 'workspace') {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => {
				this.fetchMoreProjects();
				// let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`

				// if (_.size(this.state.workspaceActiveFilter) > 0)
				// queryString = `${queryString}&tenantIds=${this.state.workspaceActiveFilter.toString()}`;
				// this.props.navigate(`/${this.props.params.vendorID}/projects${queryString}`);
			},
		);
	};
	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: [],
				currentViewPage: 1,
				isPageLoading: true,
				...(type === 'workspace' ? { workspaceFilterCleared: true } : {}),
			},
			() => this.fetchMoreProjects(),
		);
	};
	handleProjectSort = (sortBy, sortType) => {
		this.setState(
			{
				sortBy: sortBy,
				sortType: sortType,
			},
			() => this.fetchMoreProjects(),
		);
		// let filters = {
		//     filters: {
		//         limit: this.state.limit,
		//         page: this.state.currentViewPage,
		//         sortBy:sortBy,
		//         sortType:sortType
		//     }

		// }
		// this.getProjectsList(getProjects, filters)
	};
	fetchMoreProjects = async () => {
		const wsFilter = this.getActiveWorkspaceFilter();
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

		//Condition for workspace
		if (wsFilter)
			queryString = `${queryString}&workspaceIds=${wsFilter.toString()}`;

		//Condition for Searching
		if (this.state.searchValue !== '')
			queryString = `${queryString}&searchedQuery=${this.state.searchValue.toString()}`;
		if (this.state.sortBy !== '' && this.state.sortType !== 0) {
			queryString = `${queryString}&sortBy=${this.state.sortBy.toString()}&sortType=${this.state.sortType.toString()}`;
		}
		if (this.state.activeFlag !== '' && this.state.activeFlag.length > 0) {
			queryString = `${queryString}&activeFlag=${this.state.activeFlag.toString()}`;
		}

		this.props.navigate(`/${this.props.params.vendorID}/projects${queryString}`);

		let filters = {
			filters: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
			},
			workspaceIds: wsFilter || [],
		};

		if (this.state.searchValue !== '') {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					title: this.state.searchValue,
				},
			};
		}
		if (this.state.sortBy !== '' && this.state.sortType !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,

					sortBy: this.state.sortBy,
					sortType: this.state.sortType,
				},
			};
		}
		if (this.state.activeFlag !== '' && this.state.activeFlag.length > 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,

					code: this.state.activeFlag,
				},
			};
		}
		await this.getProjectsList(getProjects, filters);
	};
	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				projectsList: {},
				isPageLoading: true,
				...(type === 'workspace' ? { workspaceFilterCleared: false } : {}),
			},
			() => {
				this.fetchMoreProjects();
			},
		);
	};

	displayShootCount(eventsArr) {
		let shootsCount = 0;

		for (let i = 0; i < eventsArr.length; i++) {
			if (eventsArr[i].date != null && eventsArr[i].date < moment().format('YYYYMMDD')) {
				shootsCount += 1;
			}
		}
		return shootsCount;
	}
	displayDeliverableCount(deliverableArray) {
		let deliverCount = 0;
		for (let i = 0; i < deliverableArray?.length; i++) {
			if (deliverableArray?.[i]?.status === 'done') deliverCount++;
		}
		return deliverCount;
	}
	displayWeddingDate(eventsArr) {
		for (let i = 0; i < eventsArr.length; i++) {
			if (eventsArr[i].name === 'wedding') {
				return moment(eventsArr[i].date, 'YYYYMMDD').format('DD MMM YYYY');
			}
		}
		return '';
	}
	displayWeddingTime(eventsArr) {
		for (let i = 0; i < eventsArr.length; i++) {
			if (eventsArr[i].name === 'wedding') {
				return eventsArr[i].time;
			}
		}
		return '';
	}

	displayTenantUsersName = (collaboratorsArray, type) => {
		let res = [];
		for (let i = 0; i < collaboratorsArray.length; i++) {
			if (collaboratorsArray[i].designations.includes(type)) {
				let filteredUser = _.filter(this.state.tenantUserList, {
					id: collaboratorsArray[i].tenantUserId,
				});
				if (_.size(filteredUser) > 0)
					res.push(`${filteredUser[0].firstName} ${filteredUser[0].lastName}`);
			}
		}
		return res.toString();
	};
	handleSearchClick() {
		console.log('search button clicked');
	}
	handleSearch = (e) => {
		this.setState(
			{
				searchValue: e.target.value,
				currentViewPage: 1,
			},
			() => {
				this.fetchMoreProjects();
				// let value = e.target.value.toLowerCase()
				// let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`
				// if (_.size(value) > 0)
				//     queryString = `${queryString}&searchedQuery=${value}`
				// this.props.navigate(
				//     `/${this.props.params.vendorID}/projects${queryString}`
				// )
			},
		);

		// let result = [];
		// result = this.state.allDataProjectsList.filter((data) => {
		// return data.title.toLowerCase().search(value) != -1;
		// // return data.title.includes(value);
		// });
		// let searchFilters = {
		//     filters:{
		//         limit:this.state.searchLim,
		//         page:this.state.searchPage,
		//     }
		// }
		//  this.getSearchedProjectsList(getSearchedDataProjects,searchFilters)
		// if(result.length>0){
		//     this.setState({
		//         totalPages:1,
		//         limit:result.length,
		//         currentViewPage:this.state.searchPage,
		//         lengthOfList:result.length,
		//         projectsList:result,
		//         searchValue:value

		//     },
		// 	// () => this.fetchMoreProjects(),
		//     )
		//     // this.setState({
		//     //     projectsList:result
		//     // })
		// }
		// else if(result.length===0){
		//     this.setState({
		//         projectsList:{}
		//     })
		// }
	};
	getWorkspaceKey(tenantId, workspacesFilters) {
		for (let i = 0; i < workspacesFilters.length; i++) {
			if (workspacesFilters[i].workspaceid === tenantId) {
				return workspacesFilters[i].workspaceKey + ' /';
			}
		}
		return '';
	}
	getWorkspacename(tenantId, workspacesFilters) {
		for (let i = 0; i < workspacesFilters.length; i++) {
			if (workspacesFilters[i].workspaceid === tenantId) {
				return workspacesFilters[i].key;
			}
		}
		return '';
	}

	handleClick() {
		alert('click event fired');
	}
	// handleProjectSort=(sortBy,sortType)=>{
	//     let filters = {
	//         filters: {
	//             limit: this.state.limit,
	//             page: this.state.currentViewPage,
	//             sortBy:sortBy,
	//             sortType:sortType
	//         }

	//     }
	//     this.getProjectsList(getProjects, filters)

	// }
	render() {
		return (
			<div className="layout-wrapper">
				{this.state.isLoading ? (
					<>
						<LoadingBar />
					</>
				) : (
					<div className="container">
						<div className="searchContainer">
							{/* <a className="title">Projects</a> */}
							{/* <div className="projects-table-outer-container">
								<Space size={[8, 0]} wrap>
									{this.state.resArray.length > 0 ? (
										<>
											{this.state.resArray.map((el) => {
												return (
													<span onClick={() => this.handleFlag(el.code)}>
														<LabelCard
															data={el.description}
															info={el.activeFlagsCount}
															checkbox={true}
															checkColor={el.color}
															bgColor={
																this.state.activeFlag === el.code
																	? '#6055EC'
																	: ''
															}
														/>
													</span>
												);
											})}
										</>
									) : (
										<></>
									)}
								</Space>
							</div> */}
							<div className="shoots-header-filters-container">
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'workspace', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={true}
									version="v2"
									applyFilter={this.applyFilter}
								/>
							</div>
							<div className="searchWrapper">
								<div className="search-inner-left">
									<span className="search-icon">
										<SearchIcon />
									</span>
									<input
										placeholder="Search Client"
										// name={this.state.searchType}
										value={this.state.searchValue}
										onChange={(event) => this.handleSearch(event)}
									/>
								</div>
								<div className="search-inner-right">
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a className="search-type">
											<b
												className={
													this.state.showSearchDropDown ? 'invert' : ''
												}
											>
												<p
													style={{
														paddingRight: '20px',
													}}
													onClick={this.handleSearchClick}
												>
													Search
												</p>
											</b>
										</a>
									</span>
								</div>
							</div>
						</div>

						<div className="filters">
							<div className="projects-table-outer-container">
								<Space size={[8, 0]} wrap>
									{this.state.resArray.length > 0 ? (
										<>
											{this.state.resArray.map((el) => {
												return (
													<span onClick={() => this.handleFlag(el.code)}>
														<LabelCard
															data={el.description}
															info={el.activeFlagsCount}
															checkbox={true}
															checkColor={el.color}
															bgColor={
																this.state.activeFlag === el.code
																	? '#6055EC'
																	: ''
															}
														/>
													</span>
												);
											})}
										</>
									) : (
										<></>
									)}
								</Space>
							</div>
						</div>

						<div className={'table project-table-list'}>
							<ProjectTable
								ptProps="yes"
								tableHeaderLeftPad={35}
								isLoading={this.state.isLoading}
								// tableHeader={`SHOOTS`}
								columns={this.state.columns}
								activeSortType={this.state.sortType}
								activeSortBy={this.state.sortBy}
								handleSort={this.handleProjectSort}
								isPageLoading={this.state.isPageLoading}
								limit={this.state.limit}
								totalPages={this.state.totalPages}
								currentViewPage={this.state.currentViewPage}
								lengthOfList={this.state.lengthOfList}
								onClickNextPage={this.onClickNextPage}
								onClickPreviousPage={this.onClickPreviousPage}
								dataList={this.state.projectsList}
								goToPage={(e) => this.handleGoToPage(e)}
								// module={'project'}
								searchQuery={''}
								mainFilter={''}
								boxShadow="none"
							>
								{this.state.projectsList.length > 0 &&
									_.map(this.state.projectsList, (project, index) => {
										let eventSize = _.has(project, 'events')
											? _.size(project.events)
											: 0;

										return (
											<tr
												onClick={() => {
													let wstring = this.getWorkspacename(
														project.tenantId,
														this.state.workspacesFilters,
													);

													// this.props.navigate(
													// 	`/${this.props.params.vendorID}/shoots/${wstring}/${project.id}`,
													// );
													//testing projectsOverView
													this.props.navigate(
														`/${this.props.params.vendorID}/projects-overview/${wstring}/${project.id}?workspacekey=${project.tenantId}`,
													);
												}}
											>
												<td
													className="all-other-column-fixed"
													style={{
														borderLeft: '0.4px solid #383838',
														minWidth: '240px',
													}}
												>
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '10px',
																textTransform: 'capitalize',
																// alignItems: 'center',
															}}
														>
															<p>{project.title}</p>
															<p
																style={{
																	color: '#B0B0B0',
																}}
															>
																{this.getWorkspaceKey(
																	project.tenantId,
																	this.state.workspacesFilters,
																)}{' '}
																PJ {project.slNo}
															</p>
														</span>
													</div>
												</td>
												<td
													className="all-other-column-fixed"
													style={{
														textAlign: 'center',
														maxWidth: '60px',
													}}
												>
													{/* <div className="project-general-box"> */}
													{/* <span
															className={`completed-shoots `}
															style={{
																display: 'flex',

																gap: '10px',
																alignItems: 'center',
																justifyContent: 'center',
															}}
														> */}
													<p
														style={{
															color:
																eventSize ===
																	this.displayShootCount(
																		project.events,
																	) &&
																eventSize !== 0 &&
																this.displayShootCount(
																	project.events,
																) !== 0
																	? 'green'
																	: '#E4E5E6',
														}}
													>
														{eventSize
															? this.displayShootCount(
																	project.events,
															  ) +
															  '/' +
															  eventSize
															: '-'}
													</p>
													{/* </span> */}
													{/* </div> */}
												</td>
												<td
													className="all-other-column-fixed"
													style={{
														textAlign: 'center',
														maxWidth: '60px',
													}}
												>
													<p
														style={{
															color:
																project?.deliverables?.length ===
																	this.displayDeliverableCount(
																		project.deliverables,
																	) &&
																project?.deliverables?.length !==
																	0 &&
																this.displayDeliverableCount(
																	project.deliverables,
																) !== 0
																	? 'green'
																	: '#E4E5E6',
														}}
													>
														{project?.deliverables?.length
															? this.displayDeliverableCount(
																	project.deliverables,
															  ) +
															  '/' +
															  project?.deliverables?.length
															: '-'}
													</p>
												</td>

												<td
													className="all-other-column-fixed"
													style={{
														textAlign: 'center',
														maxWidth: '60px',
														color: '#E4E5E6',
														fontSize: '12px',
													}}
												>
													<p>
														{project?.hardDrives?.length
															? project.hardDrives.length
															: '-'}
													</p>
												</td>
												<td className="all-other-column-fixed">
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																justifyContent:
																	!project.collaborators
																		? 'center'
																		: '',
																width: '100%',
															}}
														>
															<p>
																{project.collaborators
																	? this.displayTenantUsersName(
																			project.collaborators,
																			'photographer',
																	  )
																	: '-'}
															</p>
														</span>
													</div>
												</td>
												<td className="all-other-column-fixed">
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																justifyContent:
																	!project.collaborators
																		? 'center'
																		: '',
																width: '100%',
															}}
														>
															<p>
																{project.collaborators
																	? this.displayTenantUsersName(
																			project.collaborators,
																			'videographer',
																	  )
																	: '-'}
															</p>
														</span>
													</div>
												</td>
												<td className="all-other-column-fixed">
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '10px',
																// alignItems: 'center',
															}}
														>
															<p
																style={{
																	textAlign: 'left',
																}}
															>
																{eventSize &&
																_.has(project.firstEvent, 'date') &&
																project.firstEvent.date != null
																	? moment(
																			project.firstEvent.date,
																			'YYYYMMDD',
																	  ).format('DD MMM YYYY')
																	: '-'}
															</p>
															<p
																style={{
																	color: '#B0B0B0',
																	textTransform: 'capitalize',
																}}
															>
																{eventSize &&
																_.has(project.firstEvent, 'date')
																	? project.firstEvent.name
																	: '-'}
															</p>
														</span>
													</div>
												</td>
												<td className="all-other-column-fixed">
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '10px',
																// alignItems: 'center',
															}}
														>
															<p>
																{_.has(
																	project.weddingEvent,
																	'date',
																) &&
																project.weddingEvent.date != null
																	? moment(
																			project.weddingEvent
																				.date,
																			'YYYYMMDD',
																	  ).format('DD MMM YYYY')
																	: ''}
															</p>
															<p
																style={{
																	color: '#B0B0B0',
																	textTransform: 'capitalize',
																}}
															>
																Wedding
															</p>
														</span>
													</div>
												</td>
												<td className="all-other-column-fixed">
													<div className="project-general-box">
														<span
															className={`completed-shoots `}
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '10px',
																// alignItems: 'center',
															}}
														>
															<p>
																{eventSize &&
																project.lastEvent != null
																	? moment(
																			project.lastEvent.date,
																			'YYYYMMDD',
																	  ).format('DD MMM YYYY')
																	: '-'}
															</p>
															<p
																style={{
																	color: '#B0B0B0',
																	textTransform: 'uppercase',
																}}
															>
																{eventSize &&
																project.lastEvent != null
																	? project.lastEvent.name
																	: '-'}
															</p>
														</span>
													</div>
												</td>
											</tr>
										);
									})}
							</ProjectTable>
						</div>
					</div>
				)}
			</div>
		);
	}
}
export default withRouter(Projects);
